<template>
  <section class="py-5 introduce-page">
    <div class="container">
      <!-- 主標題 + 小標題 -->
      <header class="text-center mb-5">
        <h1 class="page-title">{{ $t('nav.products') }}</h1>
        <!-- <p class="page-subtitle text-muted">{{ $t('introduce.subtitle') || '我們提供數位設計、手作材料與居家生活提案' }}</p> -->
      </header>

      <!-- 小區塊：原本的三個網站介紹 -->
      <!-- <section class="website-intro mb-5">
        <h3 class="block-dashed">{{ $t('introduce.sections.websiteIntro') }}</h3>
        <div class="row justify-content-center">
          <div class="col-12 col-md-8 col-lg-6 d-flex">
            <router-link to="/web-design" class="card-link-wrapper">
              <div class="card shadow-sm flex-fill h-100 card-hover">
                <div class="ratio ratio-16x9">
                  <img src="/inritek-web/images/introduce0.png" alt="Web Design" class="card-img-top object-fit-cover" />
                </div>
                <div class="card-body d-flex flex-column text-center">
                  <h5 class="card-title mb-2">{{ $t('introduce.sections.websiteIntro') }}</h5>
                   <p class="card-text text-muted">{{ $t('introduce.viewMore') }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </section> -->

      <!-- 第二區塊：勾針棉線（品牌 1） -->
      <section class="website-intro mb-5">
        <h3 class="block-dashed">{{ $t('introduce.sections.crochet') }}</h3>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
          <div v-for="(brand, i) in crochetBrands" :key="i" class="col d-flex">
            <!-- 根據是否有 link 決定渲染 a 標籤或 div -->
            <a v-if="brand.link" :href="brand.link" target="_blank" rel="noopener noreferrer" class="card-link-wrapper">
              <div class="card shadow-sm flex-fill h-100 card-hover">
                <div v-if="brand.image" class="ratio ratio-16x9">
                  <img :src="brand.image" :alt="brand.name || 'N/A'" class="card-img-top object-fit-cover" />
                </div>
                <div class="card-body d-flex flex-column">
                  <h5 class="card-title mb-2">{{ brand.name || 'N/A' }}</h5>
                  <!-- <p class="card-text text-muted mb-4">{{ brand.description || 'N/A' }}</p> -->
                </div>
              </div>
            </a>
            <div v-else class="card shadow-sm flex-fill h-100">
              <div v-if="brand.image" class="ratio ratio-16x9">
                <img :src="brand.image" :alt="brand.name || 'N/A'" class="card-img-top object-fit-cover" />
              </div>
              <div class="card-body d-flex flex-column">
                <h5 class="card-title mb-2">{{ brand.name || 'N/A' }}</h5>
                <!-- <p class="card-text text-muted mb-4">{{ brand.description || 'N/A' }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 第三區塊：居家生活（品牌 2） -->
      <section class="website-intro mb-5">
        <h3 class="block-dashed">{{ $t('introduce.sections.homeLiving') }}</h3>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
          <div v-for="(brand, i) in homeLivingBrands" :key="i" class="col d-flex">
            <a v-if="brand.link" :href="brand.link" target="_blank" rel="noopener noreferrer" class="card-link-wrapper">
              <div class="card shadow-sm flex-fill h-100 card-hover">
                <div v-if="brand.image" class="ratio ratio-16x9">
                  <img :src="brand.image" :alt="brand.name || 'N/A'" class="card-img-top object-fit-cover" />
                </div>
                <div class="card-body d-flex flex-column">
                  <h5 class="card-title mb-2">{{ brand.name || 'N/A' }}</h5>
                  <!-- <p class="card-text text-muted mb-4">{{ brand.description || 'N/A' }}</p> -->
                </div>
              </div>
            </a>
            <div v-else class="card shadow-sm flex-fill h-100">
              <div v-if="brand.image" class="ratio ratio-16x9">
                <img :src="brand.image" :alt="brand.name || 'N/A'" class="card-img-top object-fit-cover" />
              </div>
              <div class="card-body d-flex flex-column">
                <h5 class="card-title mb-2">{{ brand.name || 'N/A' }}</h5>
                <!-- <p class="card-text text-muted mb-4">{{ brand.description || 'N/A' }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 第四區塊：美妝品（品牌 3 & 4） -->
      <section class="website-intro mb-5">
        <h3 class="block-dashed">{{ $t('introduce.sections.cosmetics') }}</h3>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
          <div v-for="(brand, i) in cosmeticBrands" :key="i" class="col d-flex">
            <a v-if="brand.link" :href="brand.link" target="_blank" rel="noopener noreferrer" class="card-link-wrapper">
              <div class="card shadow-sm flex-fill h-100 card-hover">
                <div v-if="brand && brand.image" class="ratio ratio-16x9">
                  <img :src="brand.image" :alt="brand.name || 'N/A'" class="card-img-top object-fit-cover" />
                </div>
                <div class="card-body d-flex flex-column">
                  <h5 class="card-title mb-2">{{ (brand && brand.name) || 'N/A' }}</h5>
                </div>
              </div>
            </a>
            <div v-else class="card shadow-sm flex-fill h-100">
              <div v-if="brand && brand.image" class="ratio ratio-16x9">
                <img :src="brand.image" :alt="brand.name || 'N/A'" class="card-img-top object-fit-cover" />
              </div>
              <div class="card-body d-flex flex-column">
                <h5 class="card-title mb-2">{{ (brand && brand.name) || 'N/A' }}</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
//import { RouterLink } from 'vue-router'
const { t } = useI18n()

// 勾針棉線品牌
const crochetBrands = computed(() => [
  {
    name: t('introduce.brands.crochet.bugeto.name'),
    description: t('introduce.brands.crochet.bugeto.description'),
    image: '/inritek-web/images/bugeto.png',
    link: 'https://wonyarn.com/product-category/bugeto-%e5%9c%9f%e8%80%b3%e5%85%b6%e7%b7%9a%e6%9d%90/'
  },
  {
    name: t('introduce.brands.crochet.joudy.name'),
    description: t('introduce.brands.crochet.joudy.description'),
    image: '/inritek-web/images/joudy.jpg',
    link: 'https://wonyarn.com/product-category/joudy%e5%96%ac%e8%92%82%e5%9f%83%e5%8f%8a%e6%a3%89%e7%b7%9a/'
  }
]);

// 居家生活品牌
const homeLivingBrands = computed(() => [
  {
    name: t('introduce.brands.homeLiving.IRT.name'),
    description: t('introduce.brands.homeLiving.IRT.description'),
    image: '/inritek-web/images/IRT.png',
    link: 'https://wonyarn.com/product-category/irt-%e5%9f%83%e5%8f%8a%e6%b5%b4%e5%b7%be/'
  }
]);

//美妝品牌
const cosmeticBrands = computed(() => [
  // {
  //   name: t('introduce.brands.cosmetics.wonyarn.name'),
  //   description: t('introduce.brands.cosmetics.wonyarn.description'),
  //   image: '/inritek-web/images/wonyarn.png',
  //   link: 'https://wonyarn.com/' // WONYARN 有連結
  // },
  {
    name: t('introduce.brands.cosmetics.goddes.name'),
    description: t('introduce.brands.cosmetics.goddes.description'),
    image: '/inritek-web/images/goddes.png',
    link: 'https://www.inritek.com.tw/#/goddes'
  }
]);
</script>

<style scoped>
.page-title { font-size: 2rem; font-weight: 700; margin-bottom: 0.5rem; }
.page-subtitle { color: #666; margin-bottom: 1.25rem; }

/* 區塊標題樣式 */
.block-dashed {
  display: flex; /* Enable flexbox for alignment */
  align-items: center; /* Vertically center the text and lines */
  justify-content: center; /* Center the entire block (text + lines) */
  font-weight: 700;
  color: #0b2b4a;
  margin-bottom: 18px;
  letter-spacing: 1px;
  white-space: nowrap; /* Prevent the text from wrapping if lines are long */
}

.block-dashed {
  text-align: center;
  font-weight: 700;
  color: #0b2b4a;
  margin-bottom: 18px;
  letter-spacing: 1px;
}

.block-dashed::before,
.block-dashed::after {
  content: '';
  flex-grow: 1; /* Allow lines to take up available space */
  height: 2px; /* Line thickness */
  margin: 0 15px; /* Space between text and lines */
}

.block-dashed::before {
  /* Gradient for the left line: fades from transparent to the color */
  background: linear-gradient(to right, rgba(215, 236, 255, 0), #D7ECFF);
}

.block-dashed::after {
  /* Gradient for the right line: fades from the color to transparent */
  background: linear-gradient(to left, rgba(215, 236, 255, 0), #D7ECFF);
}

/* Website intro cards (保持原有 card 風格) */
.object-fit-cover { object-fit: cover; }
.card-title { font-weight: 600; }

/* 卡片連結包裝器 */
.card-link-wrapper {
  display: block;
  text-decoration: none;
  color: inherit;
  width: 100%;
}

/* 卡片 hover 效果 */
.card-hover {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.card-link-wrapper:hover .card-hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

/* service block layout (we reuse the same card styles) */
.website-intro .card {
  background: #fff;
  border-radius: 8px;
}

/* RWD: already uses bootstrap grid; adjust small tweaks */
@media (max-width: 992px) {
  .page-title { font-size: 1.6rem; }
}
</style>
